// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3R2CW","content":"styles_content__2xRLI","tableWrap":"styles_tableWrap__yKGKI"};